import { render, staticRenderFns } from "./tyontulevaisuus.vue?vue&type=template&id=0cd6e318&"
import script from "./tyontulevaisuus.vue?vue&type=script&lang=js&"
export * from "./tyontulevaisuus.vue?vue&type=script&lang=js&"
import style0 from "./tyontulevaisuus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports